// Component: src/theme/sections/services.liquid

import { debounce } from "@app/utils/debounce";

const init = (force=false) => {
  const services = document.querySelectorAll('.section-services');

  services.forEach((service) => {
    const scrollProgress = service.querySelector('.scroll-progress');
    const scrollTrack = service.querySelector('.scroll-track');

    if (!scrollProgress || !scrollTrack) {
      return;
    }

    const setScrollProgressWidth = () => {
      const width = scrollTrack.getBoundingClientRect().width;
      const scrollWidth = scrollTrack.scrollWidth;
      scrollProgress.style.width = `${((width + scrollTrack.scrollLeft) / scrollWidth) * 100}%`;
    }

    setScrollProgressWidth();

    if (force) {
      scrollTrack.addEventListener('scroll', setScrollProgressWidth, { passive: true });
    }
  });

}

document.addEventListener('DOMContentLoaded', () => {
  init(true);
});

const initDebounced = debounce(init, 1000);
window.addEventListener('resize', () => {
  initDebounced();
});
